import { render, staticRenderFns } from "./articoli_simili.vue?vue&type=template&id=2ef012e9"
import script from "./articoli_simili.vue?vue&type=script&lang=js"
export * from "./articoli_simili.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports